const closeBtn = {
    cursor: 'pointer',
    float: 'right',
    marginTop: -5,
    marginRight: -1,
    width: 23,
    height: 23,
    padding: 0
};

const modalStyle = {
    style: {},
    main: {
        width: 660
    },
    title: {
        padding: '25px 30px 13px 30px',
        fontSize: 24
    },
    body: {
        padding: '0 29px 0 31px',
        fontSize: 12
    },
    footer: {
        padding: '43px 30px 30px'
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, .1)'
    }
};

const tooltipStyle = {
    fontSize: 12,
    lineHeight: 1.5,
    padding: '10px 20px',
    border: 0
};

const btnStyle = {
    width: 190,
    height: 36,
    borderRadius: 3,
    color: '#fff'
};

export {closeBtn, modalStyle, tooltipStyle, btnStyle}


// WEBPACK FOOTER //
// src/components/media/modal-style.js